import {
    WidgetStrategy,
    WidgetStrategyWithStreamByRequestUid,
} from 'widgets/WidgetRegistry';
import SymbolInfo from './SymbolInfo';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { symbolInfoDescription } from './description/symbolInfoDescription';
import { symbolInfoStreamConfig } from 'widgets/symbolInfo/store/stream-config';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import { GetSymbolInfoRequestPayload } from 'widgets/symbolInfo/SymbolInfoRequest';

export const symbolInfoWidgetStrategy: WidgetStrategy &
    WidgetStrategyWithStreamByRequestUid<GetSymbolInfoRequestPayload> = {
    title: 'Symbol Info',
    supportedHosts: ['layout'],
    reactComponentType: SymbolInfo,
    categories: [WidgetCategory.SINGLE_STOCK],
    description: symbolInfoDescription,
    managedStreamConfig: symbolInfoStreamConfig,
    portfolioSelectionRequirements: PortfolioSelectionRequirements.SingleSymbol,
};
